import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { t } from './i18n';

// ============================================================
// Numarul de WhatsApp al clientului (19 octombrie 2026, APROBARE_CLIENT_PLAN.md, hotararea 5).
//
// Cu numarul in fisa, „Trimite clientului pe WhatsApp" din compozitor deschide direct
// conversatia lui. Fara numar, WhatsApp cere alegerea contactului, ca pana acum.
// Se deschide din pagina clientului, doar pentru agentie (RLS pe `clienti` lasa doar
// super adminul si managerul sa scrie). Numarul se pastreaza doar cu cifre, cu prefixul
// tarii (40722123456), cum il cere linkul wa.me.
// ============================================================

// „0722 123 456", „+40 722 123 456", „0040722123456" → „40722123456". Gol → null.
export function numarWhatsApp(text) {
  let n = String(text || '').replace(/\D/g, '');
  if (!n) return null;
  if (n.startsWith('00')) n = n.slice(2);
  else if (n.length === 10 && n.startsWith('0')) n = `40${n.slice(1)}`;
  return n.length >= 8 && n.length <= 15 ? n : '';
}

export default function TelefonClient({ client, onInchide }) {
  const [numar, setNumar] = useState('');
  const [incarcat, setIncarcat] = useState(false);
  const [seSalveaza, setSeSalveaza] = useState(false);
  const [eroare, setEroare] = useState('');

  useEffect(() => {
    let activ = true;
    supabase.from('clienti').select('telefon_whatsapp').eq('id', client.id).maybeSingle().then(({ data }) => {
      if (!activ) return;
      setNumar(data && data.telefon_whatsapp ? `+${data.telefon_whatsapp}` : '');
      setIncarcat(true);
    });
    return () => { activ = false; };
  }, [client.id]);

  async function salveaza() {
    const curat = numarWhatsApp(numar);
    if (curat === '') { setEroare(t('clienti', 'telefonGresit')); return; }
    setSeSalveaza(true);
    setEroare('');
    const { error } = await supabase.from('clienti').update({ telefon_whatsapp: curat }).eq('id', client.id);
    setSeSalveaza(false);
    if (error) { setEroare(error.message); return; }
    onInchide();
  }

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2 className="modal-titlu">{t('clienti', 'telefonTitlu', { nume: client.nume })}</h2>
        <p style={{ fontSize: 13, color: '#374151', marginTop: 0 }}>{t('clienti', 'telefonExplicatie')}</p>
        <div className="modal-camp">
          <label className="label" htmlFor="telefon-whatsapp">{t('clienti', 'telefonEticheta')}</label>
          <input
            id="telefon-whatsapp"
            type="tel"
            inputMode="tel"
            className="select-input"
            placeholder="+40 722 123 456"
            value={numar}
            disabled={!incarcat || seSalveaza}
            onChange={e => setNumar(e.target.value)}
          />
        </div>
        {eroare && <p style={{ color: '#B91C1C', fontSize: 13 }}>{eroare}</p>}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button type="button" className="btn-secundar" onClick={onInchide} disabled={seSalveaza}>{t('clienti', 'anuleaza')}</button>
          <button type="button" className="btn-principal" onClick={salveaza} disabled={!incarcat || seSalveaza}>
            {seSalveaza ? t('clienti', 'telefonSeSalveaza') : t('clienti', 'telefonSalveaza')}
          </button>
        </div>
      </div>
    </div>
  );
}
